import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "10",
  height: "16",
  viewBox: "0 0 10 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "stroke",
      d: "M5.31235 12.091L5 11.8412L4.68765 12.091L0.5 15.4412V1C0.5 0.818936 0.721816 0.5 1.25 0.5H8.75C9.27818 0.5 9.5 0.818936 9.5 1V15.4412L5.31235 12.091Z",
      stroke: "#F2994A"
    }, null, -1)
  ])))
}
export default { render: render }